import React from 'react';
import { MatchHistory } from '../components/Match';

const HistoryPage: React.FC = () => {
  return (
    <div className="space-y-6">
      {/* Page Header */}
      <div className="bg-white rounded-lg shadow-sm p-6">
        <h1 className="text-2xl font-bold text-gray-900">比赛历史</h1>
        <p className="text-gray-600 mt-1">查看所有历史比赛记录和详细信息</p>
      </div>

      {/* Content */}
      <MatchHistory />
    </div>
  );
};

export default HistoryPage;